function filterCurrentCards(brand, identifier){
  const allCards = document.querySelectorAll(`.expansible-card--${identifier}`)
  const allFilters = document.querySelectorAll('.filter-exp')
  allFilters.forEach(card => card.classList.remove('selected-filter'))
  allCards.forEach(card => card.classList.add('hidden-block'))

  const selectedFilter= document.querySelector(`.filter--${brand}-${identifier}`)
  if(selectedFilter){
    selectedFilter.classList.add('selected-filter')
  }

  const selectedFilterCards = document.querySelectorAll(`.${brand}--${identifier}`)
  if(selectedFilterCards){
    selectedFilterCards.forEach(card => card.classList.remove('hidden-block'))
  }
}

window.addEventListener('DOMContentLoaded', () => {
  filterCurrentCards('caffeine', 'ingredientsCarousel')
});